const {createContext} = require("react");

const {Provider, Consumer} = createContext();

exports.TooltipProvider = Provider;
exports.TooltipConsumer = Consumer;
